import React from 'react'
import { Text } from "@chakra-ui/core";

const MediumText = props => <Text {...props} fontSize='md'  />

export default MediumText